import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectStarRating = createSelector(selectJsonQuery, jsonQuery => getTermsValue('star_rating')(jsonQuery));
